// Helpers shared by every modal module.
//
// Each modal owns:
//  - a TEMPLATE string with its full markup (kept in this folder)
//  - a `mount` function that injects the markup into <body> idempotently
//  - one or more `open*` / `close*` functions exposed to main.ts via window.*

declare const lucide: any;

export function unmountById(id: string): void {
  document.getElementById(id)?.remove();
}

export function mountTemplate(id: string, template: string): HTMLElement | null {
  unmountById(id);
  document.body.insertAdjacentHTML('beforeend', template);
  // Render any [data-lucide] icons inside the freshly mounted markup.
  if (typeof lucide !== 'undefined') {
    try {
      lucide.createIcons();
    } catch {
      /* lucide may not be ready yet; main.ts will call createIcons later */
    }
  }
  return document.getElementById(id);
}

export function show(id: string): void {
  const el = document.getElementById(id);
  if (el) el.style.display = 'flex';
}

export function hide(id: string): void {
  const el = document.getElementById(id);
  if (el) el.style.display = 'none';
}
